//Roadmap

import styled from 'styled-components'
import { useInView } from 'react-intersection-observer';
import { show } from '../utils/utils';

const Roadmap = styled.div`
// border: 1px solid white;
color: white;    
height: 100vh;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
line-height: 1rem;
`


export default function ROADMAP() {
    // const { ref, inView } = useInView({ triggerOnce: true });
    const { ref, inView } = useInView({});

    return (

        <Roadmap ref={ref} id='roadmap' className={show(inView)}>
                <p>
                    总共1024个 每个售价0.01ETH
                </p>
                <p>  每个钱包最多Mint2个</p>
                <p> 每个NFT在mint出来后的7天内无理由退款</p>
                <p> 所有退款的NFT是打到V神的钱包里 给他老人家留个纪念</p>
                <p> 项目的初心是希望NFT都能在某个时间段内有托底 比如people </p>
                <p> 持有NFT的福利是进入妙妙屋 妙妙屋里面什么都没有( •̀ ω •́ )✧✧</p>
                <p>  Each wallet can Mint up to 2 </p>
                <p> There is a 7-day no-reason refund after each NFT has been Minted </p>
                <p> All refunds go to Vitalik's wallet as a souvenir </p>
                <p> The original intention of the project is to have a bottom guarantee for NFTs at some point in time, such as $people </p>
                <p> The benefits of holding NFTs are to enter the Wonderland House, where there is nothing (•̀ ω •́ )✧✧ </p>
                <p> 🙌 {' '} Email : skyone.nanshan@gmail.com  </p>

        </Roadmap>

    )
}